import {
  Avatar,
  Paper,
  Stack,
  Typography,
  Grid,
  MenuItem,
} from "@mui/material";
import React, { useRef } from "react";
import BoxContainer from "../../components/container/boxContainer";
import { appImages } from "../../assets";
import Label from "../../components/label";
import InputField from "../../components/InputField";
import CustomSelect from "../../components/select";
import GlobalButton from "../../components/button";
import ConfirmRequestDialog from "./ConformDialog";
import PaymentMethodDialog from "../../components/payMethodDialog.js";
import { useNavigate } from "react-router-dom";

const allClasses = [
  "1st class",
  "2nd class",
  "3rd class",
  "4th class",
  "5th class",
  "6th class",
  "7th class",
  "8th class",
  "9th class",
  "10th classs",
];

const allGrades = ["A+1", "A", "B", "C", "D", "E"];
const feeType = ["Installment 1", "Installment 2", "Installment 3"];

const ApplicationForm = () => {
  const openAdmissinRequestDialog = useRef(null);
  const openPaymentDialog = useRef(null);
  const naviagte = useNavigate();

  const handleOpenPaymentDialog = () => {
    openAdmissinRequestDialog.current.closeDialog();
    openPaymentDialog.current.openDialog();
  };

  const handleSubmitForm = () => {
    openPaymentDialog.current.closeDialog();
    naviagte("/education-city");
  };

  return (
    <BoxContainer
      sx={{
        paddingX: { xs: 1, sm: 2.5, md: 4 },
      }}
    >
      <Stack textAlign={"center"}>
        <Typography variant="heading_services" fontWeight={600}>
          Application Form
        </Typography>
        <Typography variant="heading_sec">
          For the purpose of industry regulation, your details are required.
        </Typography>
      </Stack>

      {/* School Logo */}
      <Stack alignItems={"center"} my={3}>
        <Avatar
          src={appImages.business2Img}
          sx={{
            height: { xs: 100, md: 150 },
            width: { xs: 100, md: 150 },
          }}
        />
      </Stack>

      <Typography mb={1} variant="h6" fontWeight={600}>
        Personal Information
      </Typography>
      <Grid container my={2} spacing={2}>
        <Grid item xs={12} sm={3}>
          <Label text="First name" required htmlFor={"std_first_name"} />
          <InputField
            id={"std_first_name"}
            required
            // styleProps={globalStyle.textField}
            placeholder={"Enter first name"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label text="Last name" required htmlFor={"std_last_name"} />
          <InputField
            id={"std_last_name"}
            // styleProps={globalStyle.textField}
            required
            placeholder={"Enter last name"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label text="Birthday" required htmlFor={"std_birth_date"} />
          <InputField
            id={"std_birth_date"}
            type="date"
            // styleProps={globalStyle.textField}
            required
            placeholder={"Enter Email address"}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Label text="Gender" required htmlFor={"std_gender"} />

          <CustomSelect>
            <MenuItem>Male</MenuItem>
            <MenuItem>Female</MenuItem>
            <MenuItem>Other</MenuItem>
          </CustomSelect>
        </Grid>
        <Grid item xs={12}>
          <Label text="First Address" required htmlFor={"std_first_address"} />
          <InputField
            id={"std_first_address"}
            // styleProps={globalStyle.textField}
            required
            placeholder={"Enter first address"}
          />
        </Grid>
        <Grid item xs={12}>
          <Label text="2nd Address" required htmlFor={"std_second_address"} />
          <InputField
            id={"std_second_address"}
            // styleProps={globalStyle.textField}
            required
            placeholder={"Enter first address"}
          />
        </Grid>
      </Grid>

      <Typography mb={1} variant="h6" fontWeight={600}>
        Contact Information
      </Typography>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={4}>
          <Label text="Mobile number" required htmlFor={"std_mobile_number"} />
          <InputField
            id={"std_mobile_number"}
            // styleProps={globalStyle.textField}
            required
            placeholder={"Enter mobile number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label text="Home number" required htmlFor={"std_home_number"} />
          <InputField
            id={"std_home_number"}
            // styleProps={globalStyle.textField}
            required
            placeholder={"Enter home number"}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Label text="Emial Address" required htmlFor={"std_email_number"} />
          <InputField
            id={"std_email_number"}
            // styleProps={globalStyle.textField}
            required
            placeholder={"Enter Email address"}
          />
        </Grid>
      </Grid>

      <Typography mb={1} variant="h6" fontWeight={600}>
        Previous School details
      </Typography>
      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            text="Previous class"
            required
            htmlFor={"std_previous_class"}
          />
          <CustomSelect>
            {allClasses.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            text="Previous school name"
            required
            htmlFor={"std_previous_school_name"}
          />
          <InputField
            id={"std_previous_school_name"}
            required
            // styleProps={globalStyle.textField}
            placeholder={"Enter previous school name"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label text="Last class grade" required htmlFor={"std_last_grade"} />
          <CustomSelect>
            {allGrades.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label text="Attendance" required htmlFor={"std_attendance"} />
          <InputField
            id={"std_attendance"}
            required
            // styleProps={globalStyle.textField}
            placeholder={"Enter attendance"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            text="Student repeated class"
            required
            htmlFor={"std_repeated_class"}
          />
          <CustomSelect>
            <MenuItem value={"Yes"}>Yes</MenuItem>
            <MenuItem value={"No"}>No</MenuItem>
          </CustomSelect>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label
            text="Class Name"
            required
            htmlFor={"std_repeated_class_name"}
          />
          <CustomSelect>
            {allClasses.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12}>
          <Label
            text="Reason leaving previous school"
            required
            htmlFor={"std_leave_reason"}
          />
          <InputField
            id={"std_leave_reason"}
            required
            multiline
            rows={3}
            // styleProps={globalStyle.textField}
            placeholder={"Enter attendance"}
          />
        </Grid>
      </Grid>
      <Typography variant="h6" fontWeight={600}>
        Current Admission
      </Typography>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Label text="Class" required htmlFor={"std_current_class"} />
          <CustomSelect>
            {allClasses.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label text="Fee Type" required htmlFor={"std_fee_type"} />
          <CustomSelect>
            {feeType.map((val, ind) => {
              return <MenuItem key={ind}>{val}</MenuItem>;
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Label text="Admission Fee" required htmlFor={"std_fees"} />
          <InputField
            id={"std_fees"}
            required
            // styleProps={globalStyle.textField}
            placeholder={"E.g ; 800 USD"}
            InputEndIcon={
              <Typography variant="body1" color={"primary.main"}>
                Fixed
              </Typography>
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label text="Tuition Fee" required htmlFor={"std_tuition_fees"} />
          <InputField
            id={"std_tuition_fees"}
            required
            // styleProps={globalStyle.textField}
            placeholder={"E.g ; 250 USD"}
            InputEndIcon={
              <Typography variant="body1" color={"primary.main"}>
                Fixed
              </Typography>
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Label text="Annual Fee" required htmlFor={"std_annual_fees"} />
          <InputField
            id={"std_annual_fees"}
            required
            // styleProps={globalStyle.textField}
            placeholder={"E.g ; 1000 USD"}
            InputEndIcon={
              <Typography variant="body1" color={"primary.main"}>
                Fixed
              </Typography>
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2.5}>
          <Label text="Discount%" required htmlFor={"std_discount"} />
          <InputField
            id={"std_discount"}
            required
            // styleProps={globalStyle.textField}
            placeholder={"Enter discount"}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={1.5}>
          <Label text="Sub-Total" required htmlFor={"std_discount"} />
          <InputField
            id={"std_discount"}
            required
            // styleProps={globalStyle.textField}
            placeholder={"Enter discount"}
          />
        </Grid>
      </Grid>
      <Typography variant="h6" fontWeight={600}>
        Other Supporting Document Attachments{" "}
      </Typography>

      <Grid container my={1.5} spacing={2}>
        <Grid item xs={12}>
          <Label
            text={"Previous School, College, Uni Records/Transcripts"}
            required
          />
          <GlobalButton
            btnText={"Upload"}
            styleProps={{
              width: 130,
              backgroundColor: "text.orangeRed",
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Label
            text={"Previous School, College, Uni Records/Certifcate*"}
            required
          />
          <GlobalButton
            btnText={"Upload"}
            styleProps={{
              width: 130,
              backgroundColor: "text.orangeRed",
            }}
          />
        </Grid>
      </Grid>

      <Stack alignItems={"center"}>
        <GlobalButton
          btnText={"Send Admission Request"}
          handleClickBtn={() => openAdmissinRequestDialog.current.openDialog()}
          styleProps={{
            width: "auto",
            height: 45,
            backgroundColor: "text.orangeRed",
          }}
        />
      </Stack>
      <ConfirmRequestDialog
        ref={openAdmissinRequestDialog}
        handleConfirm={handleOpenPaymentDialog}
      />
      <PaymentMethodDialog
        ref={openPaymentDialog}
        handleConfirm={handleSubmitForm}
      />
    </BoxContainer>
  );
};

export default ApplicationForm;
